export const globalRadioTypes = {
  WIDE_BLACK: 'WIDE_BLACK',
  THIN_GRAY: 'THIN_GRAY'
};
